import viewName from '../constant.js'
import {
    getCarModel
} from '@/models/carModelSelect'

export default {
    name: viewName.carModelSelect,
    inject: ['showLoading', 'hideLoading'],
    data () {
        return {
            line_id: '',
            brand_name: '',
            line: '',
            dataList: [],
            modelList: [],
            brand: '',
            chosenYear: '',
        }
    },
    created () {
        this.$emit('setHeader', {
            title: '选择车型',
            showHeader: true,
            showLeft: true
        })
        this.brand = this.$route.query.brand
        this.line_id = this.$route.query.line_id
        this.line = this.$route.query.line
        this.brand_name = this.$route.query.brand_name
        this.getCarModelList()
    },
    methods: {
        getCarModelList () {
            this.showLoading()
            getCarModel({line_id: this.line_id}).then((res) => {
                this.hideLoading()
                this.dataList = res
                if (res.length) {
                    this.chosenYear = res[0].year
                    this.modelList = res[0].vehicles
                }
            })
        },
        changeYear (item) {
            this.chosenYear = item.year
            this.modelList = item.vehicles
        },
        goFromPath (item) {
            const carDetail = `${this.line} ${this.chosenYear} ${item.engine_desc} ${item.gearbox_type} ${item.standard_name}`
            this.$router.push({
                path: this.$route.query.fromPath,
                query: {
                    cate_id: this.$route.query.cate_id,
                    activeCate: this.$route.query.activeCate,
                    vehicle_id: item.vehicle_id,
                    distribution_code: this.$route.query.distribution_code,
                    carDetail
                }
            })
        }
    }
}
